"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultArchiveLostFound = void 0;
const getDefaultArchiveLostFound = () => ({
    found: false,
    snapshots: [],
});
exports.getDefaultArchiveLostFound = getDefaultArchiveLostFound;
//# sourceMappingURL=Archive.js.map